import { Alert, Text } from "@flat-ui";
import { Stack } from "@mui/material";

/**
 * @returns An error alert with an explanation for the project connection error.
 */
export function IntegrationTileError(): JSX.Element {
  return (
    <Alert
      variant="error"
      isCollapsible
      title="Connection error"
      description={(
        <Stack
          spacing={2}
        >
          <Text
            variant="bodyM"
          >
            This project connection was created in HoloBuilder and needs to be updated for Sphere XG.
            However, we couldn't complete the update.
          </Text>
          <Text
            variant="bodyM"
          >
            This typically happens when the connected project is no longer available.
            You can verify your access to the connected project or disable this connection.
          </Text>
        </Stack>
      )}
      sx={{
        marginBottom: "8px",
      }}
    />
  );
}
